import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Sparkles, Tag, Gift } from "lucide-react";
import { HIDE_SALES } from "../lib/siteConfig";

const TABS = [
  { to: "/family-deals", label: "Find Me", icon: Sparkles, testid: "find-me-tab-family" },
  { to: "/sales", label: "Local Sales", icon: Tag, testid: "find-me-tab-sales", hideable: true },
  { to: "/giveaways", label: "Free Giveaways", icon: Gift, testid: "find-me-tab-giveaways", hideable: true },
];

export default function FindMeTabs() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const tabs = TABS.filter((t) => !(HIDE_SALES && t.hideable));
  // With only the Family Deals tab left, a lone pill is pointless — hide the bar entirely.
  if (tabs.length < 2) return null;
  return (
    <div data-testid="find-me-tabs" className="flex flex-wrap gap-2">
      {tabs.map((t) => {
        const active = pathname === t.to;
        const Icon = t.icon;
        return (
          <button
            key={t.to}
            onClick={() => navigate(t.to)}
            data-testid={t.testid}
            className={`inline-flex items-center gap-2 h-10 px-4 rounded-full text-sm font-bold transition-all ${
              active ? "bg-brand text-white shadow" : "bg-white text-ink-soft border border-line hover:border-brand/40"
            }`}
          >
            <Icon size={16} /> {t.label}
          </button>
        );
      })}
    </div>
  );
}
